import { trackEvent } from './track-event'

export function trackPartnerProfileEntryClick(variant: string, merchantPublicId: number) {
  trackEvent({
    event: 'partner_profile_entry_click',
    variant,
    merchant_public_id: merchantPublicId,
  })
}
